var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$vuetify.breakpoint.mdAndUp)?_c('campaigns-table-view',{attrs:{"loading":_vm.isLoading,"campaigns-list":_vm.campaignsList,"show-reserved-until":""},scopedSlots:_vm._u([{key:"tableActions",fn:function(ref){
var data = ref.data;
return [_vm._t("tableActions",null,{"data":data})]}}],null,true)}):_c('campaigns-list-view',{attrs:{"loading":_vm.isLoading,"campaigns-list":_vm.campaignsList},scopedSlots:_vm._u([{key:"clickableCampaignItem",fn:function(ref){
var data = ref.data;
return [_vm._t("clickableCampaignItem",null,{"data":data})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }